// Supabase client configuration for Cyrano frontend
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Use Clerk for authentication, not Supabase Auth
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  }
});

// Helper function to get authenticated Supabase client with Clerk token
export async function getAuthenticatedSupabase(getToken: (options?: { template?: string }) => Promise<string | null>) {
  const token = await getToken({ template: 'supabase' });

  if (!token) {
    throw new Error('No authentication token available');
  }

  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  });
}
